import React from 'react';
import { AddablePanelEmptyState } from './PanelEmptyState';
import { ScenesEmptyIllustration } from './empty-illustration';

interface ScenesEmptyStateProps {
  canEdit: boolean;
  onAdd: () => void;
}

export const ScenesEmptyState: React.FC<ScenesEmptyStateProps> = ({ canEdit, onAdd }) => {
  return (
    <AddablePanelEmptyState
      illustration={<ScenesEmptyIllustration />}
      titleKey="scenes_empty_title"
      descriptionKey="scenes_empty_description"
      addLabelKey="add_scene"
      canEdit={canEdit}
      onAdd={onAdd}
    />
  );
};
